import { Show, TopToolbar, Button, useNotify, useShowController, useRedirect, useRefresh } from "react-admin";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import permissions from "app/permissions";
import { CampaignSubTypePaths, CampaignSubTypes, CampaignTypes, CandidacyStates } from "utils/constants";
import { candidateRequests } from "api/candidateApi";
import CandidacyData from "./CandidacyData";
import UserData from "./UserData";
import ReturnEdittingModal from "../ReturnModal";
import { fetchJson } from "server/dataProvider/dataProvider.utils";
import CandidacyDeclarations from "./components/CandidacyDeclarations";
import RejectCandidacyManager from "./components/RejectCandidacyManager";
import CandidacyPayments from "./components/CandidacyPayments";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";

export const changeState = async (candidacyId, stateId, comment) => {
  return await fetchJson({
    url: `${process.env.REACT_APP_GATEWAY_API}/${candidateRequests.updateCandidacyStatus(candidacyId)}`,
    data: { stateId: stateId, comment: comment || null },
    method: "PUT",
  });
};

const ShowCandidate = () => {
  const { record } = useShowController();

  const redirect = useRedirect();
  const notify = useNotify();
  const refresh = useRefresh();
  // const notApprovedTransactionSize = record?.transactions?.find(
  //   x => x.providerId === PaymentProvider.CashPayment && x.status === "Processing",
  // );

  const CandidateActions = () => (
    <TopToolbar sx={{ paddingTop: "2rem", paddingRight: "2rem", gap: "1rem" }}>
      {record?.stateId === CandidacyStates.WaitingApproval &&
        checkPermission(getPermissions(), permissions.canMakeCandidacyCorrections) && (
          <ReturnEdittingModal
            record={record}
            candidacyId={record?.id}
          />
        )}

      <RejectCandidacyManager
        candidacyId={record?.id}
        hasApprovedRanking={record?.hasApprovedRanking}
      />

      {record?.stateId === CandidacyStates.WaitingApproval &&
        checkPermission(getPermissions(), permissions.canApproveCandidacies) && (
          <ConfirmModal
            titleButton={"Одобри Кандидатура"}
            titleContent="Сигурен ли сте, че искате да одобрите тази кандидатура?"
            onConfirm={async () => {
              await changeState(record?.id, CandidacyStates.Approved);
              refresh();
              notify("Кандидатурата е одобрена успешно", { type: "success" });
            }}
          />
        )}
      {record?.stateId === CandidacyStates.WaitingManualPayment &&
        checkPermission(getPermissions(), permissions.canApproveCandidacies) && (
          <ConfirmModal
            titleButton={"Плати и Одобри Кандидатура"}
            titleContent="Сигурен ли сте, че искате да одобрите тази кандидатура?"
            onConfirm={async () => {
              await changeState(record?.id, CandidacyStates.Approved);
              refresh();
              notify("Кандидатурата е одобрена успешно", { type: "success" });
            }}
          />
        )}
      <Button
        label="Назад"
        variant="contained"
        size="medium"
        color="error"
        onClick={async () => {
          try {
            await dataProvider.create(`candidate/candidacies/${record?.id}/unlock`);
            redirect(`/candidate/${CampaignSubTypePaths[record.campaignSubTypeId] ?? "none"}/candidacies`);
            notify("Успешно отключена!", { type: "success" });
          } catch (error) {
            notify(
              "Заявката не може да бъде изпълнена! Избраната кандидатура вече е отключена! Използвайте страничното меню за навигация",
              { type: "error" },
            );
          }
        }}
      >
        <ArrowBackIcon />
      </Button>
    </TopToolbar>
  );

  const isForeigner = record?.info?.citizenshipId === 2 || record?.info?.citizenshipId === 3;

  return (
    <Show
      title={`Детайли за кандидатура на ${
        record?.info?.citizenshipId === 2 || record?.info?.citizenshipId === 3
          ? "чужденец"
          : record?.info?.citizenshipId === 1
            ? "българин"
            : ""
      }`}
      actions={<CandidateActions />}
    >
      <UserData
        record={record}
        isForeigner={isForeigner}
      />
      <CandidacyPayments
        candidacyId={record?.id}
        candidacyStateId={record?.stateId}
        isForeigner={isForeigner}
        usingPreparatoryClass={record?.preparatoryClass}
        disabled={record?.hasApprovedRanking}
      />
      <CandidacyData isForeigner={isForeigner} />
      {record?.campaignTypeId !== CampaignTypes.PreparatoryCourses &&
        record?.campaignTypeId !== CampaignSubTypes.Preliminary && (
          <CandidacyDeclarations
            record={record}
            isForeigner={isForeigner}
          />
        )}
    </Show>
  );
};

export default ShowCandidate;
